
export enum SurveyOutcomeTypes {
  Complete = 0,
  Termination = 1
}
